export enum FeatureToggle {
  PhotoSearch = 'all.photo_search',
  WopiTestMode = 'wopi_test_mode',
  TimelineV2 = 'web.timeline_v2',
  People = 'peopleapi',
  PostHog = 'web.posthog',
}
